import { render, staticRenderFns } from "./CostList.vue?vue&type=template&id=b4955a60&scoped=true"
import script from "./CostList.vue?vue&type=script&lang=ts"
export * from "./CostList.vue?vue&type=script&lang=ts"
import style0 from "./CostList.vue?vue&type=style&index=0&id=b4955a60&prod&scoped=true&lang=css"
import style1 from "./CostList.vue?vue&type=style&index=1&id=b4955a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4955a60",
  null
  
)

export default component.exports